import { AccountService } from "src/app/services/account.service";
import { ApiService } from "./../../services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute } from "@angular/router";
import { CompanyList } from "src/app/models/company-list";
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { SignalRService } from "src/app/services/signalr.service";
import { FavService } from "src/app/services/fav.service";
import { OrderBuyComponent } from "src/app/components/order-buy/order-buy.component";
import { MatDialog } from "@angular/material/dialog";
import { CompanyDetails } from "src/app/models/company-details";
import Swal from "sweetalert2";
declare const TradingView: any;

@Component({
  selector: "app-company-profile",
  templateUrl: "./company-profile.component.html",
  styleUrls: ["./company-profile.component.scss"],
})
export class CompanyProfileComponent implements OnInit, AfterViewInit {
  symbolCode: any;
  company: CompanyList;
  reuters: any;
  @ViewChild("tradingTechnical") tradingTechnical?: ElementRef;
  @ViewChild("tradingFinancial") tradingFinancial?: ElementRef;
  isMarket: boolean;
  sector: string;
  tempReuters: string;
  isDarkTheme: boolean;
  companyDetails: CompanyDetails;
  isLoading=false;

  constructor(
    private _service: ApiService,
    private route: ActivatedRoute,
    private signalService: SignalRService,
    private favService: FavService,
    public dialog: MatDialog,
    public translate: TranslateService,
    private _renderer2: Renderer2,
    private accService: AccountService
  ) {
    this.signalService.connectMarketWatch();
    this.signalService.marketChanges.subscribe((res: any) =>
      res.forEach((element) => {
        if (element.SYMBOL_CODE == this.symbolCode) {
          this.company = element;
          // this._service.fetchCompany(this.symbolCode).subscribe((res) => {
          //   this.company = res as CompanyList;
          // });
        }
      })
    );

    this.accService.isFullMarketUser.subscribe((isMarket) => {
      this.isMarket = isMarket;
    });
  }

  ngOnDestroy(): void {
    this.signalService.disconnectMwSignalr();
  }

  ngOnInit(): void {
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;
    this.route.params.subscribe((params) => {
      this.symbolCode = params["symbolCode"];
      this.reuters = params["reuters"].substring(
        0,
        params["reuters"].indexOf(".")
      );

      this._service.fetchCompany(this.symbolCode).subscribe((res) => {
        this.company = res as CompanyList;
        this.sector = this.company.ENG_DESC;
        this.tempReuters = this.company.Reuters;
        this.fetchSymbolBO();
      });
      this.ngAfterViewInit();
    });
  }

  ngAfterViewInit() {
    new TradingView.widget({
      width: "100%",
      height: 550,
      symbol: "EGX:" + this.reuters,
      interval: "D",
      timezone: "Africa/Cairo",
      theme: this.isDarkTheme ? "Dark" : "Light",
      style: "1",
      locale: this.translate.currentLang == "ar" ? "ar_AE" : "en",
      toolbar_bg: "#1c1c1c",
      enable_publishing: false,
      withdateranges: true,
      // range: "ytd",
      hide_side_toolbar: false,
      allow_symbol_change: true,
      show_popup_button: true,
      popup_width: "1000",
      popup_height: "650",
      no_referral_id: true,
      container_id: "tradingview_bac65",
    });

    let script = this._renderer2.createElement("script");
    script.type = `text/javascript`;
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js";
    script.text = `  {
      "interval": "1D",
      "width": "100%",
      "height":"500",
      "isTransparent": true,
      "symbol": "EGX:${this.reuters}",
      "showIntervalTabs": true,
      "locale": "${this.translate.currentLang == "ar" ? "ar_AE" : "en"}",
      "colorTheme":  "${this.isDarkTheme ? "dark" : "light"}"
    }`;

    let scriptt = this._renderer2.createElement("script");
    scriptt.type = `text/javascript`;
    scriptt.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-financials.js";
    scriptt.text = `  {
      "width": "100%",
      "height":"500",
      "isTransparent": true,
      "symbol": "EGX:${this.reuters}",
      "displayMode": "regular",
      "largeChartUrl": "",
      "locale": "${this.translate.currentLang == "ar" ? "ar_AE" : "en"}",
      "colorTheme": "${this.isDarkTheme ? "dark" : "light"}"
    }`;

    const existingTech = this.tradingTechnical?.nativeElement;
    const existingFin = this.tradingTechnical?.nativeElement;
    if (existingFin || existingTech) {
      this.tradingTechnical?.nativeElement.replaceChildren(script);
      this.tradingFinancial?.nativeElement.replaceChildren(scriptt);
    } else {
      this.tradingTechnical?.nativeElement.appendChild(script);
      this.tradingFinancial?.nativeElement.appendChild(scriptt);
    }
  }

    fetchSymbolBO() {    
    if (this.company?.SYMBOL_CODE) {
      this.isLoading = true;
      this._service
        .fetchSymbolBO(this.company.SYMBOL_CODE)
        .subscribe({
          next: (res: CompanyDetails) => {
            if(res==null)
            {
              Swal.fire({
                    position: "center",
                    icon: "error",
                    title: this.translate.instant("Symbol_not_registered_in_BO"),
                    showConfirmButton: true                                 
                  }).then(()=>window.location.reload());
                  
              return;
              }
            else{          
            this.companyDetails = res;
            this.isLoading = false; 
          }
        },
          error: (error) => {
            this.isLoading = false; 
          }
        });
    }
  }

  isFav(symbol) {
    return this.favService.isFav(symbol);
  }

  toggleFav(symbol) {
    this.favService.toggleFav(symbol,this.favService.selectedMarketWatchId);
  }
  orderBuy(company, isSell) {
    const dialogRef = this.dialog.open(OrderBuyComponent, {
      disableClose: true,
      panelClass: "order-dialog-container",
      data: { symbol: company, type: isSell },
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }
 get numberFormat(): string {
    const digits = this.companyDetails?.RoundDigits != null ? this.companyDetails.RoundDigits : 3;
    return `1.${digits}-${digits}`;
  }
}
